export * from '@fluentui/theme/lib/fonts/DefaultFontStyles';
